import React, { useEffect } from 'react';

const DocusignSenderCallbackPage = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const event = params.get('event');
    const txId = params.get('txId');
    const documentId = params.get('documentId');
    const offerId = params.get('offerId');
    const envelopeId = params.get('envelopeId');

    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        {
          type: 'DOCUSIGN_SENDER_CALLBACK',
          event,
          txId,
          documentId,
          offerId,
          envelopeId,
        },
        window.location.origin
      );
      window.close();
    }
  }, []);

  return (
    <div style={{ padding: '32px', textAlign: 'center' }}>
      <h2>DocuSign Sender Callback</h2>
      <p>You can close this window.</p>
    </div>
  );
};

export default DocusignSenderCallbackPage;
